export const SIGNUP_FLOW_STEPS = {
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  PHONE_NUMBER_VERIFICATION: "PHONE_NUMBER_VERIFICATION",
  PROFESSIONAL_DETAILS_SUBMITTED: "PROFESSIONAL_DETAILS_SUBMITTED",

 
  // PROFESSIONAL_DETAILS_SUBMITTED: "PROFESSIONAL_DETAILS_SUBMITTED",

  DOCUMENTS_UPLOADED: "DOCUMENTS_UPLOADED",
  LOCATION_DETAILS_SUBMITTED: "LOCATION_DETAILS_SUBMITTED",

  EDUCATION_DETAILS_SUBMITTED: "EDUCATION_DETAILS_SUBMITTED",
  SKILLS_SUBMITTED: "SKILLS_SUBMITTED",

  BANK_DETAILS_SUBMITTED: "BANK_DETAILS_SUBMITTED",
  FR_REGISTERED: "FR_REGISTERED",
  TERMS_ACCEPTED: "TERMS_ACCEPTED",
};
